import React, {useContext, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FilterDropdown from "../FilterDropdown.jsx";
import {FilterContext} from "./DashboardFilterContextProvider.jsx";
import Select from "react-select";
import Badge from "../Badge.jsx";
import {faGlobeEurope} from "@fortawesome/free-solid-svg-icons/faGlobeEurope";

export default function DomainFilter() {
    let {t} = useTranslation();

    let {domainsPossible, projectDomainsCount, domainsAllowListed, setDomainsAllowListed} = useContext(FilterContext);

    let [selectOpened, setSelectOpened] = useState(false);

    let {selectValue, selectOptions, selectedAmount, possibleAmount} = useMemo(() => {
        let selectValue = [];
        let selectOptions = [];
        let selectedAmount = 0;
        let possibleAmount = 0;

        for (let possibleDomain of domainsPossible) {
            if(possibleDomain.projectDomain.isEnabled === false) {
                continue;
            }

            possibleAmount++;

            if (domainsAllowListed.includes(possibleDomain.projectDomain.id)) {
                selectedAmount++;
                selectValue.push({
                    value: possibleDomain.projectDomain.id,
                    label: possibleDomain.projectDomain.hostName,
                });
            }

            selectOptions.push({
                value: possibleDomain.projectDomain.id,
                label: possibleDomain.projectDomain.hostName,
            });
        }

        return {
            selectValue: selectValue,
            selectOptions: selectOptions,
            selectedAmount: selectedAmount,
            possibleAmount: possibleAmount,
        };

    }, [domainsPossible, domainsAllowListed]);

    if (projectDomainsCount < 2) {
        return null;
    }

    return (<FilterDropdown
        title={t('filter.domains')}
        align={'right'}
        button={<div className={'flex justify-center items-center text-nowrap gap-2'}>
            <FontAwesomeIcon icon={faGlobeEurope}/>
            {t('filter.domains')}
            {(selectedAmount !== 0 && selectedAmount < possibleAmount) &&
                <Badge>{selectedAmount}/{possibleAmount}</Badge>}
        </div>}
        inhibitClosing={selectOpened}
    >
        <ul>
            <Select
                isMulti
                options={selectOptions}
                value={selectValue}
                menuPortalTarget={document.body}
                menuPosition='fixed'
                noOptionsMessage={() => t('filter.no-domains-found')}
                onMenuOpen={() => setSelectOpened(true)}
                onMenuClose={() => setTimeout(() => setSelectOpened(false), 100)}
                onChange={(val) => setDomainsAllowListed(val.map((obj) => obj.value))}
                className={'datixo_select_container w-96'}
                classNamePrefix={'datixo_select'}
            />
        </ul>
    </FilterDropdown>);
}
